import {
  RbacActionScope,
  RbacPermissionRuleType,
  RbacRequestScope,
  RbacResource,
  // rbacPermissionRuleLabelMap,
} from 'api/rbac/rbac-types';
import { AddonFeature, useAddon } from 'hooks/use-addon';
import { useIsAccountInEnterpriseBillingType } from 'hooks/use-enterprise';
import { AccountPermissionSetType } from 'stores/permission-sets';

type PermissionRuleType = {
  [key in RbacResource]?: {
    action: RbacPermissionRuleType;
    scope?: RbacRequestScope;
    actionScope?: RbacActionScope;
  };
};

export type AccountPermissionType = keyof typeof AccountPermissionSetType;

export type RolePermissionMap = {
  [key in AccountPermissionType]?: PermissionRuleType;
};

export interface PermissionData {
  permissionId: number;
  permissionRule: RbacPermissionRuleType;
  permissionObjectType: RbacResource;
  actionScope: RbacActionScope;
  requestScope: RbacRequestScope;
}

export const generateRolePermissionMap = (permissionData: PermissionData[]) => {
  return permissionData.reduce((acc, { permissionRule }) => {
    const permissionDetail = {
      // permissionLabel:
      //   rbacPermissionRuleLabelMap[permissionRule.permissionName],
      permissionId: permissionRule.permissionId,
    };

    acc[permissionRule.permissionId] = permissionDetail;

    return acc;
  }, {});
};

export const useHasAccessToRbac = () => {
  const hasRbacAddon = useAddon(AddonFeature.Rbac);
  const isAccountInEnterpriseBillingType =
    useIsAccountInEnterpriseBillingType();

  return isAccountInEnterpriseBillingType || hasRbacAddon;
};
